import { FaMapMarkerAlt } from 'react-icons/fa'
import { IoIosArrowForward } from 'react-icons/io'

import {
  Box,
  Circle,
  HStack,
  Icon,
  Square,
  Text,
  VStack,
} from '@chakra-ui/react'

import { GuardTour } from '@/components/icons'

export interface TourPlanListItemIProps {
  label: string
  subLabel: string | number
  selected?: boolean
  onClick?: () => void
}

export const TourPlanListItem = ({
  label,
  subLabel,
  selected,
  onClick,
}: TourPlanListItemIProps) => {
  return (
    <HStack
      _active={{
        backgroundColor: selected ? '#D8E2FF' : '#DCDFE4',
        boxShadow:
          '0px 0px 1px rgba(9, 30, 66, 0.31), 0px 1px 1px rgba(9, 30, 66, 0.25)',
      }}
      _hover={{
        backgroundColor: selected ? '#D8E2FF' : '#F1F2F4',
        boxShadow:
          '0px 0px 1px rgba(9, 30, 66, 0.31), 0px 8px 12px rgba(9, 30, 66, 0.15)',
      }}
      backgroundColor={selected ? '#EDF0FF' : '#fff'}
      borderRadius='4px'
      boxShadow='0px 0px 1px rgba(9, 30, 66, 0.31), 0px 1px 1px rgba(9, 30, 66, 0.25)'
      cursor='pointer'
      justifyContent='space-between'
      onClick={onClick}
      p='8px'
      role='group'
      transition='ease-in-out'
      transitionDuration='300ms'
      transitionProperty='all'
    >
      <HStack flexShrink={1} isTruncated minWidth='0' spacing='12px'>
        <Square
          _groupHover={{
            backgroundColor: '#43BF9B',
          }}
          bgColor='#7FABFF'
          borderRadius='5px'
          size='32px'
          transition='ease-in-out'
          transitionDuration='300ms'
          transitionProperty='all'
        >
          <Icon as={GuardTour} color='#fff' />
        </Square>

        <VStack align='flex-start' flexShrink={1} isTruncated spacing='0'>
          <Text
            color='#172B4D'
            fontSize='14px'
            fontWeight={500}
            isTruncated
            lineHeight='20px'
            w='full'
          >
            {label}
          </Text>

          <Box w='full'>
            <HStack>
              <Box>
                <FaMapMarkerAlt color='#44546F' size={10} />
              </Box>
              <Text
                color='#172B4D'
                fontSize='12px'
                fontWeight={400}
                isTruncated
                lineHeight='18px'
              >
                {subLabel}
              </Text>
            </HStack>
          </Box>
        </VStack>
      </HStack>
      <Circle
        _groupHover={{
          opacity: 1,
        }}
        bgColor='rgba(9, 30, 66, 0.06)'
        borderRadius='full'
        opacity={0}
        size='40px'
        transition='ease-in-out'
        transitionDuration='300ms'
        transitionProperty='all'
      >
        <IoIosArrowForward color='#44546F' size='20px' />
      </Circle>
    </HStack>
  )
}
